import {
  Currency,
  PayerPayrollSettings,
  PaymentMethodRef
} from "@wingspanhq/wingspan-api-sdk";

/**
 * The method that funds a contractor payroll run in `currency`, or `undefined`
 * when nothing can fund it.
 *
 * `defaultFundingSource` is the fallback rather than the primary: a payer that
 * has named a per-currency source meant it for that currency.
 */
export const selectorPayrollFundingSource = (params: {
  payrollSettings?: PayerPayrollSettings;
  currency: Currency;
}): PaymentMethodRef | undefined =>
  params.payrollSettings?.fundingSourcesByCurrency?.[params.currency] ??
  params.payrollSettings?.defaultFundingSource;
